import { render } from "./AccessModule.vue?vue&type=template&id=c111caf0&scoped=true&ts=true"
import script from "./AccessModule.vue?vue&type=script&lang=ts"
export * from "./AccessModule.vue?vue&type=script&lang=ts"

import "./AccessModule.vue?vue&type=style&index=0&id=c111caf0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c111caf0"]])

export default __exports__